import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/viaAdmin';
import Via from './ViaAdministracion';


const ms2p = (state) => {
  return {
    ...state.rs_via_admin,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Via);